import type { HandwritingCandidate } from "../handwriting/handwriting-lookup.js";
import type { HandwritingSource } from "./handwriting-source.js";
import type { StrokePoints } from "../handwriting/stroke-shape.js";
import { characterShape } from "../handwriting/stroke-shape.js";
import { lookUpHandwriting } from "../handwriting/handwriting-lookup.js";

/**
 * What the ink on the square comes back as.
 *
 * The index is asked for here rather than held, so a reader faster than the
 * network is shown the message under the square until it arrives. A page that
 * has already fetched it is answered without waiting for anything.
 *
 * The scan itself is a few milliseconds over 9,276 characters and runs after
 * every stroke. See `handwriting-lookup.ts` for why there is nothing worth
 * debouncing.
 */

/** How many candidates a reader is offered. */
const mostCandidates = 8;

/** The characters the strokes most nearly match, best first. */
export async function handwritingCandidates(properties: {
  /** Where the index comes from. */
  readonly source: HandwritingSource;

  /** What the reader has drawn so far. */
  readonly strokes: readonly StrokePoints[];
}): Promise<readonly HandwritingCandidate[]> {
  return lookUpHandwriting({
    index: await properties.source.index(),
    shape: characterShape(properties.strokes),
    limit: mostCandidates,
  });
}
